<template>
    <div class="modal-card small_modal floating_frame">
        <section class="floating_frame_container">
            <div class="button_container">
                <div v-for="counterpart in allCounterparts" v-bind:key="counterpart">
                    <SimpleButton @click="toggle(counterpart)"
                        :class="['period_button', { 'period_button_selected': is_on(counterpart) }]">
                        <div class="fila_filter nobreak">
                            <div :class="['subelement', 'check_filter', { 'check_space': !is_on(counterpart) }]">
                                {{ counterpart_symbol(counterpart) }}</div>
                            <div class="subelement name_filter"> {{ counterpart }}</div>
                        </div>
                    </SimpleButton>
                </div>
            </div>
        </section>
    </div>

</template>


<script>
import SimpleButton from "./SimpleButton.vue";


export default {
    name: "ChangePeriodTimeframe",
    components: {
        SimpleButton,
    },
    data() {
        return {
            how_many_months: '',
        };
    },
    methods: {
        counterpart_symbol(counterpart) {
            return this.counterpartsOn.includes(counterpart) ? "✓" : "-";
        },
        is_on(counterpart) {
            return this.counterpartsOn.includes(counterpart);
        },
        toggle(counterpart) {
            if (this.counterpartsOn.includes(counterpart)) {
                const index = this.counterpartsOn.indexOf(counterpart);
                this.counterpartsOn.splice(index, 1);
            } else {
                this.counterpartsOn.push(counterpart)
            }
        }
    },
    props: {
        allCounterparts: {
            type: Array,
            required: true,
        },
        counterpartsOn: {
            type: Array,
            required: true,
        },
    },
};
</script>

<style scoped>
.fila_filter {
    width: 100%;
    display: flex;
    align-items: center;
}

.subelement {
    height: 1.29em;
}

.check_space {
    color: #e9e9ed00;
}

.check_filter {
    width: 1.6em;
    text-align: center;
}

.name_filter {
    text-align: center;
    margin-left: 1em;
    width: 14em;
}

.floating_frame {
    position: absolute;
    z-index: 1000;
    background-color: #eeeeee;
}

.input_months {
    width: 60px;
}

.button_container {
    display: flex;
    flex-direction: column;
    align-items: stretch;
}

.period_button_selected {
    background-color: #dddd77;
}

.period_button {
    position: relative;
    margin: 4px 3px 4px 3px;
    width: 10.4em;
}

.small_modal {
    width: 170px;
}

.nobreak {
    white-space: nowrap;
}
</style>
